module.exports = __webpack_public_path__ + "static/img/korea-cash-payment.523c5ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/korea-cash-payment.jpg
// module id = mHr7
// module chunks = 0